import { AnyCustomFieldDefinition } from '@payaca/custom-fields';
import { assertUnreachable } from '@payaca/utilities/guards';
import { ComponentProps, FC } from 'react';

import { BooleanFieldInput } from './components/BooleanFieldInput';
import { EmailFieldInput } from './components/EmailFieldInput';
import { NumberFieldInput } from './components/NumberFieldInput';
import { SelectFieldInput } from './components/SelectFieldInput';
import { TextareaFieldInput } from './components/TextareaFieldInput';
import { TextFieldInput } from './components/TextFieldInput';
import {
  UploadFieldInput,
  UploadFieldInputProps,
} from './components/UploadFieldInput';
import { UrlFieldInput } from './components/UrlFieldInput';
import { UserCustomFieldInput } from './components/UserCustomFieldInput';

type FieldInputSwitchProps = {
  definition: AnyCustomFieldDefinition;
  value: any;
  onChange: (value: any) => void;
  users?: ComponentProps<typeof UserCustomFieldInput>['users'];
  handlePersistUpload?: UploadFieldInputProps['handlePersistUpload'];
};

const FieldInputSwitch: FC<FieldInputSwitchProps> = (props) => {
  const { definition, value, onChange, users, handlePersistUpload } = props;

  switch (definition.type) {
    case 'text':
      return (
        <TextFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'textarea':
      return (
        <TextareaFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'email':
      return (
        <EmailFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'number':
      return (
        <NumberFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'select':
      return (
        <SelectFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'boolean':
      return (
        <BooleanFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'url':
      return (
        <UrlFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
        />
      );
    case 'upload':
      return handlePersistUpload ? (
        <UploadFieldInput
          definition={definition}
          value={value}
          onChange={onChange}
          handlePersistUpload={handlePersistUpload}
        />
      ) : null;
    case 'user':
      return (
        <UserCustomFieldInput
          allowUnset={!definition.isRequired}
          value={value}
          users={users || []}
          onChange={onChange}
        />
      );
    case 'duration':
    case 'multi-upload':
    case 'fieldset':
      return <i>Unsupported field type: {definition.type}</i>;
    default:
      assertUnreachable(definition);
  }
};

export default FieldInputSwitch;
